const zhTranslations = {
  language_label: "语言",
  vietnamese: "越南语",
  chinese: "中文",
  english: "英语",
  open_categories: "打开分类菜单",
  search_placeholder: "搜索产品、产品编号或品牌...",
  customer_utilities: "客户功能",
  account_fallback: "账户",
  logout_success: "已成功退出登录",
  logout_failed: "退出登录失败",
  generic_error_retry: "发生错误，请稍后重试。",
  mobile_navigation: "移动端导航",
  support: "客户支持",
  back_to_top: "返回顶部",
  shipping_policy: "配送与交付",
  privacy_policy: "隐私政策",
  shopping_guide: "购买指南",
  warranty_request: "申请保修",
  send_support_request: "提交支持请求",
  technical_support_247: "全天候技术支持",
  hotline_label: "服务热线",
  breadcrumb: "面包屑导航",
  brand_label: "品牌：",
  token_expired_login: "登录已过期，请重新登录。",
  login_required_action: "请先登录后再执行此操作。",
  add_cart_success: "产品已加入购物车。",
  cart_status_updated: "产品状态已更新。",
  cart_cleared: "购物车已清空。",
  view_all: "查看全部",
  view_all_categories: "查看所有分类",
  industrial_solutions: "TTSMART 工业解决方案",
  equipment_solutions: "设备解决方案",
  for_concrete_mixing_stations: "专为混凝土搅拌站打造",
  genuine_quality: "正品保障 · 品质可靠",
  expert_technical_consulting: "专业技术咨询",
  official_warranty: "官方保修",
  explore_now: "立即探索",
  download_catalogue: "下载产品目录",
  featured_categories: "精选分类",
  loading_products: "正在加载产品...",
  add_to_favorites: "加入收藏",
  featured_brands: "精选品牌",
  view_more: "查看更多",
  product_type_label: "产品类型：",
  cluster_label: "设备组：",
  equipment_label: "设备：",
  real_image_100: "100% 实物图片",
  return_by_policy: "按政策退换货",
  reviews_suffix: "条评价",
  sold_label: "已售",
  vat_excluded: "价格不含增值税",
  buy_now: "立即购买",
  call_now: "立即致电 0813.15.83.83",
  chat_zalo: "通过 Zalo 咨询",
  hotline_number: "服务热线 0813.15.83.83",
  ttsmart_commitment: "TTSmart 服务承诺",
  nationwide_delivery: "越南全国配送",
  related_products: "相关产品",
  product_info_updating: "产品信息正在更新中。",
  manual_label: "使用手册",
  datasheet_label: "数据表",
  catalog_label: "产品目录",
  chat: "在线咨询",
  call: "致电",
  contact_for_quote: "联系询价",
  customer_information: "客户须知",
  policy_page_description: "了解 TTSmart 的购买、配送、保修及信息保护规定。",
  loading_policy_content: "正在加载政策内容...",
  policy_categories: "政策分类",
  need_help: "需要帮助？",
  support_team_ready: "TTSmart 团队随时为您解答。",
  last_updated: "最后更新：",
  policy_contact_prompt: "如果您对本政策仍有疑问，请联系我们获取支持。",
  contact_now: "立即联系",
  policy_load_error: "无法加载政策内容，请稍后重试。",
  loading_station_data: "正在加载站点数据...",
  login_required_title: "需要登录",
  login_required_station_desc: "请使用客户账户登录，以查看分配给您的站点列表。",
  assigned_stations_desc: "查看并管理已分配到您账户的站点。",
  total_stations: "站点总数",
  active_stations: "运行中的站点",
  active_station: "正常运行",
  maintenance_station: "维护中",
  stopped_station: "已停运",
  assigned_station_list: "已分配站点",
  search_stations: "搜索站点...",
  list_view: "列表",
  grid_view: "网格",
  no_matching_stations: "未找到符合条件的站点。",
  actions: "操作",
  active: "运行中",
  code_label: "编号：",
  showing: "显示",
  of: "共",
  stations_unit: "个站点",
  devices_unit: "台设备",
  per_page: "/ 页",
  item_label: "项目",
  button_count: "按钮数量",
  rows_per_page_10: "每页 10 行",
  view_details: "查看详情",
  microphone_secure_required: "浏览器要求使用 HTTPS 或 localhost 才能访问麦克风。",
  speak_longer: "请多说一会儿再点击停止。",
  listening_instructions: "正在聆听...说完后请再次点击麦克风按钮。",
  microphone_permission_error: "无法打开麦克风，请允许本网站使用麦克风。",
  processing_voice: "正在处理语音...",
  search_text_required: "请输入搜索内容。",
  processing_search: "正在处理搜索请求...",
  voice_search_placeholder: "请输入搜索内容，例如：查找 TTSM1 电磁阀",
  switch_to_text_input: "切换到键盘输入",
  switch_to_voice_input: "切换到语音搜索",
  auto_login_success: "自动登录成功！",
  auto_logging_in: "正在自动登录...",
  image_heading: "图片",
  display_range: "显示",
  page_size_10: "每页 10 条",
  page_size_20: "每页 20 条",
  page_size_50: "每页 50 条",
  policy_purchase_title: "购买政策",
  policy_warranty_title: "保修与退换货",
  policy_shipping_title: "配送与交付",
  policy_privacy_title: "隐私政策",
  policy_purchase_short: "购买",
  policy_warranty_short: "保修与退换货",
  policy_shipping_short: "配送",
  policy_privacy_short: "隐私保护",
  unknown: "未知",
  stock_quantity: "库存数量",
  add_product_to_cart: "将产品加入购物车",
  search_result_prefix: "搜索",
  audio_parse_failed: "无法识别音频内容。",
  voice_process_error: "处理语音时发生错误。",
  text_parse_failed: "无法解析搜索内容。",
  search_process_error: "处理搜索内容时发生错误。",
  close_text_input: "关闭文字输入框",
  keyboard_search: "使用键盘输入搜索内容",
  stop_and_search: "再次点击以停止并搜索",
  start_voice_search: "点击开始语音搜索",
  auto_login_missing_code: "缺少登录代码。",
  auto_login_failed: "自动登录失败。",
  auto_login_error: "自动登录时发生错误。",
  product_display_range: "显示第 {first}–{last} 件，共 {total} 件产品",
  product_code_label: "产品编码",
  manufacturer_label: "制造商",
  product_type_summary_label: "产品类型",
  color_label: "颜色",
  shape_label: "形状",
  frame_label: "框架",
  in_stock: "有货",
  remaining_products: "仅剩 {count} 件",
  pdf_document: "PDF 文档",
  technical_document: "技术文档",
  remove_from_cart: "从购物车中移除",
  product_categories: "产品分类",
  best_selling_products: "热销产品",
  genuine_products: "正品保障",
  genuine_commitment: "承诺 100% 正品",
  trusted_warranty: "可靠保修",
  fast_on_time_delivery: "快速准时送达",
  support_247: "全天候支持",
  free_technical_consulting: "免费技术咨询",
  category: "分类",
  unknown_error: "发生未知错误。",
  percent_of_total_stations: "占站点总数的 {percent}%",
  station_image: "站点图片",
  station_name: "站点名称",
  station_code: "站点编码",
  product_count: "产品数量",
  location: "位置",
  station_display_range: "显示第 {first}–{last} 个，共 {total} 个站点",
  device_display_range: "显示第 {first}–{last} 台，共 {total} 台设备",
  station_not_found: "未找到该站点。",
  updating_status: "正在更新",
  introduction_empty: "暂无公司介绍内容。",
  loading_introduction: "正在加载公司介绍...",
  introduction_load_error: "无法加载公司介绍，请稍后重试。",
  error_occurred: "发生错误",
  password_strength_weak: "弱",
  password_strength_medium: "中等",
  password_strength_good: "良好",
  password_strength_strong: "强",
  fill_all_fields: "请填写完整信息",
  password_minimum_length: "密码至少需要 6 个字符",
  change_password_failed: "密码修改失败",
  change_password_success: "密码修改成功",
  server_error: "服务器错误，请稍后重试",
  change_password_description: "请设置新密码以保护您的账户。",
  current_password_placeholder: "请输入当前密码",
  toggle_password_visibility: "显示或隐藏密码",
  new_password_placeholder: "请输入新密码",
  password_strength: "密码强度",
  password_rule_note: "密码至少需要 6 个字符，建议组合使用大小写字母、数字和特殊字符。",
  confirm_password_placeholder: "请再次输入新密码",
  encrypted_security_note: "您的信息已加密并受到安全保护。",
  copied: "订单编号已复制",
  copy_failed: "无法复制订单编号",
  other_products: "件其他产品",
  orders_description: "跟踪已提交订单的处理、配送和付款状态。",
  order_status: "订单状态",
  loading_orders: "正在加载订单...",
  unable_to_load_orders: "无法加载订单",
  try_again: "重试",
  empty_orders_hint: "没有符合当前所选状态的订单。",
  continue_shopping: "继续购物",
  copy_order_code: "复制订单编号",
  construction: "项目现场",
  full_name_required: "请输入姓名",
  account_info_description: "管理您的联系方式和收货地址。",
  personal_info_hint: "用于联系您并确认订单的信息",
  edit: "编辑",
  account_security: "账户安全",
  change_password_regularly: "定期修改密码以保护您的账户。",
  address_book_hint: "保存地址，以便更快捷地下单",
  no_saved_address_title: "尚未保存收货地址",
  add_new_address: "添加新地址",
  set_default: "设为默认地址",
  default: "默认",
  delete: "删除",
  my_addresses: "我的地址",
  my_account: "我的账户",
  customer_support_247: "全天候客户支持",
  contact_price: "请联系询价",
  product_image_alt: "产品图片",
  product_no_longer_exists: "该产品已不存在",
  register_failed: "无法注册账户。该邮箱或电话号码可能已被使用。",
  otp_send_failed: "无法发送验证码，请检查所填信息后重试。",
  reset_password_failed: "无法重置密码。验证码可能不正确或已过期。",
  order_creation_failed: "无法创建订单，请检查购物车后重试。",
};

export default zhTranslations;
